export const daysToSeconds = (days: number) => 60 * 60 * 24 * days
